// copied from here:
// https://github.com/TanStack/query/issues/6840#issuecomment-2385133632

import { useEffect, useRef } from "react";
import { replaceEqualDeep } from "./replaceEqualDeep";

export function useStable<T>(value: T) {
    const ref = useRef(value);
    // TODO: can we avoid that eslint disable?
    // eslint-disable-next-line react-hooks/refs
    const stable = replaceEqualDeep(ref.current, value);

    useEffect(() => {
        ref.current = stable;
    }, [stable]);

    return stable;
}
